import React__default from 'react';
import { Headline } from '../../atoms/headline/headline.esm.js';

var ArticlePageTitle = function ArticlePageTitle(props) {
  var title = props.title;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-title",
    className: "flex flex-col justify-center self-stretch font-serif"
  }, /*#__PURE__*/React__default.createElement(Headline, {
    as: "h1",
    className: "text-[28px] font-bold leading-[35px] sm:text-[32px] sm:leading-[40px] lg:text-[36px]"
  }, title));
};

export { ArticlePageTitle };
//# sourceMappingURL=article-title.esm.js.map
